import { msalInstance } from "@/app/providers/MsalProvider";
import type { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "@/shared/config/msal";

export async function getAccessToken(
  scopes?: string[],
  forceRefresh: boolean = false
): Promise<string | null> {
  try {
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length === 0) {
      return null;
    }

    const account = accounts[0];
    const request = {
      scopes: scopes ||
        loginRequest.scopes || ["openid", "profile", "email", "offline_access"],
      account: account,
      forceRefresh: forceRefresh,
    };

    try {
      const response = await msalInstance.acquireTokenSilent(request);
      return response.idToken;
    } catch (error) {
      if (error instanceof Error && "errorCode" in error) {
        const msalError = error as InteractionRequiredAuthError;
        const errorCode = msalError.errorCode;

        if (
          errorCode === "interaction_required" ||
          errorCode === "consent_required" ||
          errorCode === "login_required" ||
          errorCode === "token_expired"
        ) {
          try {
            const response = await msalInstance.acquireTokenPopup(request);
            return response.idToken;
          } catch (popupError) {
            console.error(
              "[Token Refresh] Failed to acquire token interactively:",
              popupError
            );
            return null;
          }
        }
      }

      if (import.meta.env.DEV) {
        console.warn("[Token Refresh] Silent acquisition failed:", error);
      }
      return null;
    }
  } catch (error) {
    console.error("Error getting access token:", error);
    return null;
  }
}
